import { Button, Stack } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiThreeDS } from '../../../openapi';
import { UseMutationResult } from '@tanstack/react-query';

export function ThreeDSActions({
  threeDS,
  mutation: { mutate, isPending, variables },
}: {
  threeDS: ApiThreeDS;
  mutation: UseMutationResult<unknown, unknown, { action: 'approve' | 'decline' }>;
}) {
  const { t } = useTranslation();

  if (threeDS.state !== 'PENDING') return null;

  const isApproving = isPending && variables?.action === 'approve';
  const isDeclining = isPending && variables?.action === 'decline';

  return (
    <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={2} width="100%">
      <Button
        size="large"
        color="secondary"
        disabled={isApproving}
        loading={isDeclining}
        onClick={() => mutate({ action: 'decline' })}
        fullWidth
      >
        {t('Reject')}
      </Button>
      <Button
        size="large"
        color="primary"
        disabled={isDeclining}
        loading={isApproving}
        onClick={() => mutate({ action: 'approve' })}
        fullWidth
      >
        {t('Confirm')}
      </Button>
    </Stack>
  );
}
